import * as React from 'react';
import { colors } from '../styles/colors';
import { CommonActionButton } from './CommonActionButton';
import { InformationIcon } from './InformationIcon';

interface IProps {
    cancelOnClick?(): void;
    confirmOnClick(): void;
    cancelText?: string;
    cancelInfoHref?: string;
    confirmContent?: React.ReactNode;
    style?: React.CSSProperties;
    altConfirmStyle?: boolean;
    confirmStyle?: React.CSSProperties;
    altPadding?: number;
    confirmDisabled?: boolean;
}

export class ModalActionButtonBar extends React.Component<IProps> {
    public render() {
        return (
            <div
                style={{
                    ...styles.container,
                    ...this.props.style,
                    ...(this.props.altPadding ? { paddingRight: this.props.altPadding, paddingLeft: this.props.altPadding } : {})
                }}
            >

                {this.props.cancelText ? (
                        <React.Fragment>
                            {this.props.cancelInfoHref &&
                                <InformationIcon
                                    link={this.props.cancelInfoHref}
                                    style={styles.cancelInfoIcon} />}
                            <CommonActionButton
                                buttonContent={this.props.cancelText}
                                onClick={this.props.cancelOnClick!}
                                containerStyle={{ ...styles.buttonContainer, ...styles.backgroundColor, marginRight: 20 }}
                                fontStyle={styles.buttonTextCancel}
                            />
                        </React.Fragment>
                ) : (
                    <div />
                )}

                {this.props.confirmContent ? (
                    <CommonActionButton
                        buttonContent={this.props.confirmContent}
                        onClick={this.props.confirmDisabled ? () => null : this.props.confirmOnClick}
                        isDisabled={this.props.confirmDisabled}
                        containerStyle={{
                            ...styles.buttonContainer,
                            ...this.props.confirmStyle,
                            ...(this.props.altConfirmStyle ? { backgroundColor: '#FBE3E6' } : {})
                        }}
                        fontStyle={{ ...styles.buttonTextConfirm, ...(this.props.altConfirmStyle ? { color: colors.CANCEL_TEXT } : {}) }}
                    />
                ) : (
                    <div />
                )}
            </div>
        );
    }
}

const styles: {[key: string]: React.CSSProperties} = {
    container: {
        width: '100%',
        height: 120,
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingLeft: '16%',
        paddingRight: '16%'
    },
    buttonContainer: {
        width: 180,
        height: 50
    },
    buttonTextCancel: {
        color: colors.CANCEL_TEXT,
        fontSize: 16,
        paddingTop: 2
    },
    buttonTextConfirm: {
        color: 'white',
        fontSize: 16,
        paddingTop: 2
    },
    backgroundColor: {
        backgroundColor: colors.ACTION_BAR
    },
    cancelInfoIcon: {
        marginRight: '0.5em',
    }
};



// WEBPACK FOOTER //
// ./src/SharedComponents/ModalActionButtonBar.tsx